import React from "react";
import DottedDetail from "../../personnel-management/form/DottedLine";
import { Typography } from "@mui/material";
import logo_ibsc from '../../../../assets/icons/logo_ibsc.png'


const LeaveForm: React.FC = () => {
    return (
        <div className="w-full m-auto">
            <header className="w-full">
                <div className="flex justify-between">
                    <Typography>
                        Ref.000001
                    </Typography>
                    <Typography>
                        {/* i18n-ignore (official form code) */}
                        บค. ๑๓
                    </Typography>
                </div>
                <div className="flex justify-center items-center">
                    <img width={100} height={100} src={logo_ibsc} alt={logo_ibsc} />
                </div>
                {/* <DottedDetail
                    label="อีเมล"
                    detail={""}
                    defaultLength={96}
                /> */}
            </header>
        </div>
    );
};

export default LeaveForm;
